import React from "react";

export const Services = (props) => (
  <div id="services" className="text-center">
    <div className="container">
      <div className="col-md-10 col-md-offset-1 section-title">
        <h2>What We Do In-House</h2>
        <p>
          Extraction, sawing, treatment, finishing, cut-to-size and export — six
          stages, one company, one point of responsibility.
        </p>
      </div>
      <div className="card-grid">
        {props.data
          ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="service-item">
                <i className={d.icon}></i>
                <div className="service-desc">
                  <h3>{d.name}</h3>
                  <p>{d.text}</p>
                </div>
              </div>
            ))
          : null}
      </div>
    </div>
  </div>
);
